import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'policy.view.policy-details.Policy Details',
        defaultMessage: 'Policy Details: {policyNumber}'
    },
    currentTab: {
        id: 'policy.view.policy-details.tab.Current',
        defaultMessage: 'Current'
    },
    changePolicy: {
        id: 'policy.view.policy-details.Change Policy',
        defaultMessage: 'Change Policy'
    },
    renewalTab: {
        id: 'policy.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewing'
    },
    DownloadIDCard: {
        id: 'policy.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card'
    },
    policyHolder: {
        id: 'policy.view.policy-details.Policy Holder',
        defaultMessage: 'Policy Holder'
    },
    effectiveDate: {
        id: 'policy.view.policy-details.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'policy.view.policy-details.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    propCovCardHeader: {
        id: 'policy.view.policy-details.Property Information',
        defaultMessage: 'Property Information'
    },
    autoCovCardHeader: {
        id: 'policy.view.policy-details.Vehicle Information',
        defaultMessage: 'Vehicle Information'
    },
    boatCovCardHeader: {
        id: 'policy.view.policy-details.Boat Information',
        defaultMessage: 'Boat Information'
    },
    myAgent: {
        id: 'policy.view.policy-details.My Agent',
        defaultMessage: 'My Agent'
    },
    myBroker: {
        id: 'policy.view.policy-details.My Broker',
        defaultMessage: 'My Broker'
    },
    na: {
        id: 'policy.view.policy-details.Not available',
        defaultMessage: 'Not available'
    },
    importantNoteTitle: {
        id: 'policy.view.policy-details.Important Note',
        defaultMessage: 'Important Note'
    },
    importantNote: {
        id: 'policy.view.policy-details.Important Note Message',
        defaultMessage: 'Please contact your Broker for any changes required to your policy.'
    },
    umbrellaCovCardHeader: {
        id: 'policy.view.policy-details.Policy Information',
        defaultMessage: 'Policy Information'
    },
    farmCovCardHeader: {
        id: 'policy.view.policy-details.Residential Information',
        defaultMessage: 'Residential Information'
    },
    notesAuthor: {
        id: 'claim.view.policy-details.Author',
        defaultMessage: 'From'
    },
    notesDate: {
        id: 'claim.view.policy-details.Date / Time',
        defaultMessage: 'Date / Time'
    },
    notesSubject: {
        id: 'claim.view.policy-details.Subject',
        defaultMessage: 'Subject'
    },
    PolicyNotesContent: {
        id: 'policy.view.policy-details.New Message',
        defaultMessage: 'New Message'
    },
    policyNotesContent: {
        id: 'policy.view.policy-details.There are no messages associated with this policy.',
        defaultMessage: 'There are no messages associated with this policy.'
    },
    PolicyMessagesContent: {
        id: 'policy.view.policy-details.Messages',
        defaultMessage: 'Messages'
    },
    noteTabImportantNote: {
        id: 'policy.view.policy-details.Important Note Message- Note Tab',
        defaultMessage: 'Sample message, to be replaced with actual wordings'
    },
    commercialCovCardHeader: {
        id: 'policy.common.component.cp-coverages-component.Commercial Property Coverages',
        defaultMessage: 'Commercial Property Coverages',
    },
    commonCovCardHeader:{
        id: 'policy.common.component.cp-coverages-component.Line Level Coverages',
        defaultMessage: 'Line Level Coverages',
    },
    additionalCoveragesCP: {
        id: 'policy.common.component.cp-coverages-component.Additional Coverages',
        defaultMessage: 'Additional Coverages',
    },
    garageCovCardHeader: {
        id: 'policy.view.policy-details.Garage Information',
        defaultMessage: 'Garage Information'
    }
    
});
